'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACTIVITY = exports.ACTIVITY = 'activity';
var AMENITY = exports.AMENITY = 'amenity';
var LEVEL = exports.LEVEL = 'level';
var LOCATION = exports.LOCATION = 'location';
var MOVEMENT = exports.MOVEMENT = 'movement';